export const LinkGroupCategories = {
	General: 1,
	Sports: 2,
	Racing: 3
};

export const LinkGroupCategoryNames = {
	[LinkGroupCategories.General]: 'General',
	[LinkGroupCategories.Sports]: 'Sport',
	[LinkGroupCategories.Racing]: 'Racing'
};
